var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 23.5C8.91548 23.5 6 20.5565 6 16.9375V7.75C6 7.26614 6.38832 6.87505 6.86661 6.87505C7.34507 6.87505 7.73339 7.26614 7.73339 7.75V16.9375C7.73339 19.5905 9.87144 21.7499 12.5 21.7499C15.1286 21.7499 17.2666 19.5905 17.2666 16.9375V7.31245C17.2666 5.62376 15.906 4.25005 14.2334 4.25005C12.5606 4.25005 11.2 5.62376 11.2 7.31245V16.0626C11.2 16.7861 11.7832 17.3751 12.5 17.3751C13.2168 17.3751 13.8 16.7861 13.8 16.0626V7.75C13.8 7.26614 14.1883 6.87505 14.6666 6.87505C15.1451 6.87505 15.5334 7.26614 15.5334 7.75V16.0626C15.5334 17.7512 14.1726 19.1249 12.5 19.1249C10.8274 19.1249 9.46661 17.7512 9.46661 16.0626V7.31245C9.46661 4.65957 11.6047 2.5 14.2334 2.5C16.8619 2.5 19 4.65957 19 7.31245V16.9375C19 20.5565 16.0845 23.5 12.5 23.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper-clip.031bc9aa8c9cfcc7df378f7f5445a355.svg";
export { ForwardRef as ReactComponent };